import VueClickAway from "vue3-click-away";

export default {
  install: function(app /*, options*/) {
    app.use(VueClickAway);
  }
};
